export default "/images/vendor/flag-icon-css/flags/4x3/ci.svg?c7146bc39c724cd34b46e01e2487c78a";